import { categoryStyle, onChainCategoryLabel, onChainCategoryStyle } from "./category-colors.js";

const STATUS_BADGE = {
  open: "Open",
  pending_yes: "Pending YES",
  pending_no: "Pending NO",
  under_review: "Council action",
  finalized: "Finalized",
  cancelled: "Cancelled",
};

function normalizeCardStatus(statusRaw) {
  if (statusRaw == null) return "open";
  if (typeof statusRaw === "number") {
    return (
      ["open", "pending_yes", "pending_no", "under_review", "finalized", "cancelled"][
        statusRaw
      ] ?? "open"
    );
  }
  const s = String(statusRaw).toLowerCase().replace(/[\s-]+/g, "");
  const compact = s.replace(/_/g, "");
  const map = {
    open: "open",
    pendingyes: "pending_yes",
    pending_yes: "pending_yes",
    pendingno: "pending_no",
    pending_no: "pending_no",
    underreview: "under_review",
    under_review: "under_review",
    finalized: "finalized",
    cancelled: "cancelled",
    canceled: "cancelled",
  };
  return map[s] ?? map[compact] ?? "open";
}

/**
 * Prototype browse / create-preview market card (WEN-local).
 * @param {object} props
 * @returns {HTMLButtonElement}
 */
export function renderWenEventCard({
  id,
  title,
  category,
  marketCategory,
  status: statusRaw,
  yesPercent,
  poolLabel,
  thinPool,
  tradeCount,
  winningOutcome,
  unverified,
  hidden,
  onClick,
}) {
  const status = normalizeCardStatus(statusRaw);
  const label = category ?? onChainCategoryLabel(marketCategory);
  const cat =
    marketCategory != null
      ? onChainCategoryStyle(marketCategory)
      : categoryStyle(label);
  const yesNum =
    yesPercent == null || Number.isNaN(Number(yesPercent))
      ? null
      : Math.round(Number(yesPercent));
  const leanYes = yesNum == null ? true : yesNum >= 50;
  const sideFg = leanYes ? "var(--side-yes-fg)" : "var(--side-no-fg)";
  const displayPct = yesNum == null ? null : leanYes ? yesNum : 100 - yesNum;

  const card = document.createElement("button");
  card.type = "button";
  card.className = "dt-card card-hover wen-event-card";
  card.style.borderTop = `2px solid ${cat.fg}`;
  if (onClick) card.addEventListener("click", () => onClick(id));

  if (label) {
    const pill = document.createElement("span");
    pill.className = "dt-pill wen-cat-pill";
    pill.style.background = cat.bg;
    pill.style.color = cat.fg;
    pill.textContent = label;
    card.append(pill);
  }

  const titleEl = document.createElement("h4");
  titleEl.className = "wen-event-card-title";
  titleEl.textContent = title ?? `Event #${id}`;
  card.append(titleEl);

  const pct = document.createElement("div");
  pct.className = "wen-event-card-pct dt-val";
  pct.style.color = sideFg;
  pct.textContent = displayPct == null ? "-" : `${displayPct}¢`;
  card.append(pct);

  const meter = document.createElement("div");
  meter.className = "dt-meter";
  const fill = document.createElement("div");
  fill.style.width = `${displayPct ?? 0}%`;
  fill.style.background = sideFg;
  meter.append(fill);
  card.append(meter);

  const meta = document.createElement("div");
  meta.className = "wen-event-card-meta dt-val";
  const bits = [];
  if (poolLabel) bits.push(`Pool ${poolLabel}`);
  if (tradeCount != null) bits.push(`${tradeCount} tx`);
  meta.textContent = bits.length ? bits.join(" · ") : STATUS_BADGE[status] ?? status;
  card.append(meta);

  const badges = document.createElement("div");
  badges.className = "wen-event-card-badges";
  const pushBadge = (label, kind = "neutral") => {
    const b = document.createElement("span");
    b.className = `dt-pill wen-badge wen-badge--${kind}`;
    b.textContent = label;
    badges.append(b);
  };
  if (status === "under_review") pushBadge("Council action", "warn");
  if (thinPool) pushBadge("Thin pool", "danger");
  if (unverified) pushBadge("Unverified", "danger");
  if (hidden) pushBadge("Hidden", "neutral");
  if (winningOutcome === 0 || winningOutcome === "yes" || winningOutcome === "YES") {
    pushBadge("YES won", "yes");
  } else if (winningOutcome === 1 || winningOutcome === "no" || winningOutcome === "NO") {
    pushBadge("NO won", "no");
  }
  if (badges.childNodes.length) card.append(badges);

  return card;
}
